export default {
  'file-management.root': 'Root',
  'file-management.storageConfig': 'Storage Config',
  'file-management.selectStorageConfig': 'Select Storage Config',
  'file-management.storageSelector.defaultConfig': 'Default Config',
  'file-management.storageSelector.currentSelection': 'Current selection',
  'file-management.storageSelector.scopeHint':
    'Switch affects current page only',
  'file-management.allStorageConfigs': 'All Storage Configs',
  'file-management.refreshData': 'Refresh Data',
  'file-management.createDefaultConfig': 'Create Default Config',
  'file-management.builtIn': 'Built-in',
  'file-management.systemDefault': 'System Default Config',
  'file-management.createDefaultConfigDescription':
    'Create a 1GB basic storage configuration for you to start using file management features immediately',
  'file-management.storageType': 'Storage Type',
  'file-management.activated': 'Activated',
  'file-management.inactive': 'Inactive',
  'file-management.dashboard.heading': 'Dashboard',
  'file-management.dashboard.subtitle':
    'View storage metrics and system overview',
  'file-management.dashboard.defaultTag': 'Default',
  'file-management.dashboard.switchStorage': 'Switch Storage',
  'file-management.dashboard.quota.full':
    'Storage is full, uploads are not allowed',
  'file-management.dashboard.quota.high':
    'Storage usage is high, consider cleaning files',
  'file-management.dashboard.quota.ok': 'Storage capacity is sufficient',
  'file-management.dashboard.unknownAuthor': 'Unknown',
  'file-management.dashboard.stats.totalFiles': 'Total Files',
  'file-management.dashboard.stats.totalFolders': 'Folders',
  'file-management.dashboard.stats.totalSize': 'Total Size',
  'file-management.dashboard.stats.todayUploads': 'Uploads Today',
  'file-management.dashboard.storageUsage.title': 'Storage Usage',
  'file-management.dashboard.storageUsage.loading': 'Loading...',
  'file-management.dashboard.storageUsage.used': 'Used',
  'file-management.dashboard.storageUsage.total': 'Total',
  'file-management.dashboard.storageUsage.remaining': 'Remaining',
  'file-management.dashboard.activity.title': "Today's Activity",
  'file-management.dashboard.activity.downloads': 'Downloads',
  'file-management.dashboard.activity.views': 'Views',
  'file-management.dashboard.activity.uploads': 'Uploads',
  'file-management.dashboard.storageAlerts.title': 'Storage Alerts',
  'file-management.dashboard.storageAlerts.resolve': 'Resolve Now',
  'file-management.dashboard.fileType.title': 'File Type Distribution',
  'file-management.dashboard.fileType.column.type': 'File Type',
  'file-management.dashboard.fileType.column.count': 'Count',
  'file-management.dashboard.fileType.column.size': 'Total Size',
  'file-management.dashboard.fileType.column.percent': 'Share',
  'file-management.dashboard.userUpload.title': 'User Upload Statistics',
  'file-management.dashboard.userUpload.column.userId': 'User',
  'file-management.dashboard.userUpload.column.count': 'Files',
  'file-management.dashboard.userUpload.column.size': 'Total Size',
  'file-management.dashboard.userUpload.column.percent': 'Share',
  'file-management.dashboard.cleanup.title': 'Cleanup Suggestions',
  'file-management.dashboard.cleanup.savingsLabel': 'Savings {amount}',
  'file-management.dashboard.cleanup.suggestionList': 'Suggested files:',
  'file-management.dashboard.cleanup.more': 'And {count} more files...',
  'file-management.dashboard.cleanup.largeFiles.title':
    'Large Files Cleanup Suggestion',
  'file-management.dashboard.cleanup.largeFiles.description':
    'Found {count} large files over 100MB, consider cleaning up to free storage space',
  'file-management.dashboard.cleanup.unusedFiles.title':
    'Unused Files Cleanup Suggestion',
  'file-management.dashboard.cleanup.unusedFiles.description':
    'Found {count} files not accessed in 90 days, consider archiving or deleting',
  'file-management.dashboard.cleanup.duplicateFiles.title':
    'Duplicate Files Cleanup Suggestion',
  'file-management.dashboard.cleanup.duplicateFiles.description':
    'Found {count} duplicate file groups, consider deleting duplicates',
  'file-management.dashboard.cleanup.duplicateFiles.groupLabel':
    '({count} duplicates, {size} each)',
  'file-management.dashboard.recentFiles.title': 'Recently Accessed Files',
  'file-management.dashboard.recentFiles.view': 'View',
  'file-management.dashboard.recentFiles.download': 'Download',
  'file-management.uploadCenter.placeholder.selectFolder':
    'Select a folder (uploads default to root)',
  'file-management.uploadCenter.field.storageLabel': 'Select storage config',
  'file-management.search.title': 'File Search',
  'file-management.search.description': 'Quickly search and locate your files',
  'file-management.search.action.search': 'Search',
  'file-management.search.total': 'Found {count} files',
  'file-management.search.empty': 'No files found',
  'file-management.search.placeholder.keyword': 'Enter keyword to search',
  'file-management.search.placeholder.fileType': 'Select file type',
  'file-management.search.placeholder.category': 'Select category',
  'file-management.search.placeholder.storageConfig': 'Select storage config',
  'file-management.search.placeholder.sort': 'Sort by',
  'file-management.search.action.view': 'View',
  'file-management.search.action.download': 'Download',
  'file-management.search.action.edit': 'Edit',
  'file-management.search.action.share': 'Share',
  'file-management.search.modal.title': 'Edit file information',
  'file-management.search.modal.field.name': 'File name:',
  'file-management.search.modal.field.description': 'Description:',
  'file-management.search.modal.field.category': 'Category:',
  'file-management.search.modal.field.tags': 'Tags:',
  'file-management.search.modal.placeholder.tags': 'Enter tags and press Enter',
  'file-management.search.category.document': 'Document',
  'file-management.search.category.image': 'Image',
  'file-management.search.category.video': 'Video',
  'file-management.search.category.audio': 'Audio',
  'file-management.search.category.archive': 'Archive',
  'file-management.search.category.other': 'Other',
  'file-management.search.sort.updatedDesc': 'Newest updated',
  'file-management.search.sort.updatedAsc': 'Oldest updated',
  'file-management.search.sort.createdDesc': 'Newest created',
  'file-management.search.sort.createdAsc': 'Oldest created',
  'file-management.search.sort.nameAsc': 'Name (A-Z)',
  'file-management.search.sort.nameDesc': 'Name (Z-A)',
  'file-management.search.sort.sizeDesc': 'Size (largest first)',
  'file-management.search.sort.sizeAsc': 'Size (smallest first)',
  'file-management.tab.storageConfig': 'Storage Config',
  'file-management.storageConfig.pageTitle': 'Storage Configuration Management',
  'file-management.storageConfig.status.default': 'Default Config',
  'file-management.settings.pageTitle': '⚙️ Settings',
  'file-management.settings.pageDescription':
    'Configure file management preferences and personalization',
  'file-management.settings.card.fileTypes.title': 'File Type Settings',
  'file-management.settings.card.fileTypes.unsavedTag': 'Unsaved changes',
  'file-management.settings.card.fileTypes.resetButton': 'Reset selection',
  'file-management.settings.card.fileTypes.unsavedTip':
    '💡 Your selections are saved locally. Click "Save Settings" to apply changes to the server.',
  'file-management.settings.card.fileTypes.validation.empty':
    'No file types selected. Please select at least one file type before saving.',
  'file-management.settings.card.fileTypes.selectByCategory':
    'Select file types by category:',
  'file-management.settings.card.fileTypes.tag.selected': 'Selected {count}',
  'file-management.settings.card.fileTypes.button.selectAll': 'Select all',
  'file-management.settings.card.fileTypes.button.deselectAll': 'Deselect all',
  'file-management.settings.card.fileTypes.validation.required':
    '⚠️ Please select at least one file type',
  'file-management.settings.fileTypeCategory.document': 'Document',
  'file-management.settings.fileTypeCategory.image': 'Image',
  'file-management.settings.fileTypeCategory.video': 'Video',
  'file-management.settings.fileTypeCategory.audio': 'Audio',
  'file-management.settings.fileTypeCategory.code': 'Code',
  'file-management.settings.fileTypeCategory.archive': 'Archive',
  'file-management.settings.fileTypeCategory.database': 'Database',
  'file-management.settings.fileTypeCategory.font': 'Font',
  'file-management.settings.fileTypeCategory.other': 'Other',
  'file-management.settings.card.upload.title': 'Upload Settings',
  'file-management.settings.field.maxFileSize': 'Max file size (MB)',
  'file-management.settings.field.maxFilesPerBatch': 'Max files per batch',
  'file-management.settings.field.autoCompress': 'Auto compression',
  'file-management.settings.field.enableDragDrop': 'Enable drag & drop uploads',
  'file-management.settings.card.download.title': 'Download Settings',
  'file-management.settings.field.enableDownload': 'Enable download',
  'file-management.settings.field.requireConfirmation':
    'Require confirmation before download',
  'file-management.settings.field.maxConcurrentDownloads':
    'Max concurrent downloads',
  'file-management.settings.card.storage.title': 'Storage Settings',
  'file-management.settings.field.autoBackup': 'Auto backup',
  'file-management.settings.field.backupInterval': 'Backup interval (hours)',
  'file-management.settings.field.retentionDays': 'Retention days',
  'file-management.settings.field.enableCompression': 'Enable compression',
  'file-management.settings.card.notification.title': 'Notification Settings',
  'file-management.settings.field.emailNotifications': 'Email notifications',
  'file-management.settings.field.uploadNotifications': 'Upload notifications',
  'file-management.settings.field.downloadNotifications':
    'Download notifications',
  'file-management.settings.field.securityAlerts': 'Security alerts',
  'file-management.settings.card.system.title': 'System Info & Actions',
  'file-management.settings.system.appVersion': 'Application version',
  'file-management.settings.system.appVersionTag': 'v1.0.0',
  'file-management.settings.system.dbVersion': 'Database version',
  'file-management.settings.system.dbVersionTag': 'v1.0.0',
  'file-management.settings.system.apiVersion': 'API version',
  'file-management.settings.system.apiVersionTag': 'v1.0.0',
  'file-management.settings.placeholder.maxFileSize': 'Enter max file size',
  'file-management.settings.placeholder.maxFilesPerBatch':
    'Enter max files per batch',
  'file-management.settings.placeholder.maxConcurrentDownloads':
    'Enter max concurrent downloads',
  'file-management.settings.placeholder.backupInterval':
    'Enter backup interval',
  'file-management.settings.placeholder.retentionDays': 'Enter retention days',
  'file-management.settings.button.saveWithFileTypeChanges':
    'Save settings (including file type changes)',
  'file-management.settings.button.save': 'Save settings',
  'file-management.settings.button.refresh': 'Refresh settings',
  'file-management.settings.button.export': 'Export settings',
  'file-management.settings.button.import': 'Import settings',
  'file-management.settings.button.reset': 'Reset settings',
  'file-management.settings.fetchFailed': 'Failed to get file settings',
  'file-management.settings.updateSuccess':
    'File settings updated successfully',
  'file-management.settings.updateFailed': 'Failed to update file settings',
  'file-management.settings.resetSuccess': 'File settings reset to default',
  'file-management.settings.resetFailed': 'Failed to reset file settings',
  'file-management.action.edit': 'Edit File',
  'file-management.action.delete': 'Delete File',
  'file-management.action.view': 'View File',
  'file-management.action.search': 'Search',
  'file-management.action.refresh': 'Refresh',
  'file-management.action.more': 'More',
  'file-management.type.document': 'Document',
  'file-management.type.image': 'Image',
  'file-management.type.video': 'Video',
  'file-management.type.audio': 'Audio',
  'file-management.type.other': 'Other',
  'file-management.field.name': 'File Name',
  'file-management.field.type': 'File Type',
  'file-management.field.size': 'File Size',
  'file-management.field.owner': 'Owner',
  'file-management.field.modifiedAt': 'Modified At',
  'file-management.field.createdAt': 'Created At',
  'file-management.message.operationFailed': 'Operation Failed',
  'file-management.message.settingsLoadFailed': 'Failed to load settings',
  'file-management.message.settingsSaved': 'Settings saved',
  'file-management.message.settingsSaveFailed': 'Failed to save settings',
  'file-management.message.settingsExported': 'Settings exported',
  'file-management.message.settingsExportFailed': 'Failed to export settings',
  'file-management.message.settingsImported': 'Settings imported',
  'file-management.message.settingsImportInvalid': 'Invalid settings file',
  'file-management.message.settingsImportFailed': 'Failed to import settings',
  'file-management.message.settingsReset': 'Settings reset to default',
  'file-management.message.settingsResetFailed': 'Failed to reset settings',
  'file-management.message.fileTypeReset': 'File type selection reset',
  'file-management.message.loadFilesFailed': 'Failed to load files',
  'file-management.message.loadConfigDetailFailed':
    'Failed to load config detail',
  'file-management.message.loadStorageStatsFailed':
    'Failed to load storage statistics',
  'file-management.message.cleanupStorageFailed': 'Failed to cleanup storage',
  'file-management.message.backupStarted': 'Backup task started',
  'file-management.message.backupStartFailed': 'Failed to start backup',
  'file-management.message.backupStopped': 'Backup task stopped',
  'file-management.message.backupStopFailed': 'Failed to stop backup',
  'file-management.message.loadingStats': 'Loading statistics...',
  'file-management.message.noStatsData': 'No statistics data',
  'file-management.message.storageConfigUpdated': 'Storage config updated',
  'file-management.message.pleaseSelectStorageConfig':
    'Please select a storage config first',
  'file-management.message.viewOfficeInNewWindow':
    'Office document opened in new window',
  'file-management.message.viewInNewWindow': 'File opened in new window',
  'file-management.message.viewFileFailed': 'Failed to view file',
  'file-management.message.downloadDisabled': 'Download is disabled',
  'file-management.message.downloadStarted': 'File download started',
  'file-management.message.downloadFailedRetry': 'Download failed, retry later',
  'file-management.message.downloadFailed': 'Download failed',
  'file-management.message.getFileDetailFailed': 'Failed to get file details',
  'file-management.message.generateShareLinkFailed':
    'Failed to generate share link',
  'file-management.message.shareFailed': 'Failed to generate share link',
  'file-management.message.fileDeleted': 'File deleted',
  'file-management.message.deleteFileFailed': 'Failed to delete file',
  'file-management.message.deleteFailed': 'Delete failed',
  'file-management.message.fileInfoUpdated': 'File info updated',
  'file-management.message.updateFileInfoFailed': 'Failed to update file info',
  'file-management.message.shareLinkCopied': 'Share link copied',
  'file-management.message.folderDeleteSuccess': 'Folder deleted successfully',
  'file-management.message.refreshStorageConfigFailed':
    'Failed to refresh storage configs, please refresh the page manually',
  'file-management.message.folderCreated': 'Folder created successfully',
  'file-management.message.loadFileDetailFailed': 'Failed to load file details',
  'file-management.message.previewNeedsComponent':
    'Preview requires a preview component',
  'file-management.message.downloadConfirmNeedsDialog':
    'Download confirmation requires a dialog',
  'file-management.message.editNeedsModal':
    'Edit feature requires an edit modal',
  'file-management.message.shareNeedsModal':
    'Share feature requires a share modal',
  'file-management.message.shareNeedsDrawer':
    'Share capability requires the file collaboration drawer',
  'file-management.message.referenceNeedsDrawer':
    'Business reference capability requires the file collaboration drawer',
  'file-management.message.folderDeleteConfirmNeedsDialog':
    'Folder delete confirmation requires a dialog',
  'file-management.message.bucketCreateFailed': 'Failed to create bucket',
  'file-management.message.bucketSwitchFailed': 'Failed to switch bucket',
  'file-management.message.bucketDeleteFailed': 'Failed to delete bucket',
  'file-management.message.noActiveConfigInDashboard':
    'No active storage config found, please activate one in Storage Configs',
  'file-management.message.initConfigFailedInDashboard':
    'Failed to initialize storage config',
  'file-management.message.loadStatsFailedInDashboard':
    'Failed to load statistics',
  'file-management.message.switchConfigFailed': 'Failed to switch config',
  'file-management.message.loadConfigsFailed': 'Failed to load configs',
  'file-management.message.defaultConfigCreateSuccess':
    'Default config created successfully',
  'file-management.message.defaultConfigCreateFailed':
    'Failed to create default config',
  'file-management.message.configNotActive':
    'This storage configuration is not active and cannot be selected',
  'file-management.message.activateConfigFailed':
    'Failed to activate storage configuration',
  'file-management.message.activateConfigSuccess':
    'Storage configuration activated',
  'file-management.storageConfig.switchAdminOnly':
    'Only tenant/org admins can switch storage configuration',
  'file-management.storageConfig.modifyAdminOnlyHint':
    'Storage configuration is managed by admins. Please contact an admin for changes.',
  'file-management.message.defaultConfigCreated':
    'System default configuration created',
  'file-management.message.createDefaultConfigFailed':
    'Failed to create default configuration',
  'file-management.message.noData': 'No Data',
  'file-management.message.uploadSuccess': 'File uploaded successfully',
  'file-management.action.download': 'Download',
  'file-management.action.share': 'Share',
  'file-management.action.reference': 'Business Reference',
  'file-management.action.createFolder': 'Create Folder',
  'file-management.action.upload': 'Upload File',
  'file-management.field.tags': 'Tags',
  'file-management.column.actions': 'Actions',
  'file-management.fileLibrary.title': 'File Library',
  'file-management.fileLibrary.description':
    'Cloud-based file management system',
  'file-management.fileLibrary.header.description':
    'File management system based on {storageType} storage, supporting complete lifecycle management of folders and files',
  'file-management.fileLibrary.status.connected': '{name} connected',
  'file-management.fileLibrary.status.disconnected': '{name} not connected',
  'file-management.fileLibrary.status.bucket': 'Bucket: {bucket}',
  'file-management.fileLibrary.status.region': 'Region: {region}',
  'file-management.fileLibrary.availableConfigCount':
    '{count} storage configuration(s) detected',
  'file-management.fileLibrary.actions.createFolder': 'Create Folder',
  'file-management.fileLibrary.actions.refresh': 'Refresh file list',
  'file-management.fileLibrary.actions.switchStorage': 'Switch Storage',
  'file-management.action.save': 'Save',
  'file-management.fileLibrary.actions.uploadFile': 'Upload File',
  'file-management.fileLibrary.actions.manageBucket': 'Manage Bucket',
  'file-management.fileLibrary.actions.manageStorage': 'Manage Storage Configs',
  'file-management.fileLibrary.unconfigured.title': 'File library unavailable',
  'file-management.fileLibrary.unconfigured.description':
    'No storage service configured yet.',
  'file-management.fileLibrary.unconfigured.primaryHint':
    'We provide 1 GB of default storage to get you started quickly.',
  'file-management.fileLibrary.unconfigured.secondaryHint':
    'Use "Configure storage" to create a default or custom storage.',
  'file-management.fileLibrary.unconfigured.primaryAction': 'Configure storage',
  'file-management.fileLibrary.modal.createFolder.title': 'Create Folder',
  'file-management.fileLibrary.modal.createFolder.nameLabel': 'Folder name',
  'file-management.fileLibrary.modal.createFolder.namePlaceholder':
    'Enter a folder name',
  'file-management.fileLibrary.modal.createFolder.storageLabel':
    'Storage config',
  'file-management.fileLibrary.modal.createFolder.storagePlaceholder':
    'Select storage config (optional)',
  'file-management.fileLibrary.modal.createFolder.storageHint':
    'If not selected, the tenant default config will be used.',
  'file-management.fileLibrary.modal.createFolder.nameHint':
    'Avoid special characters and duplicate names.',
  'file-management.fileLibrary.modal.createFolder.validation.required':
    'Please enter a folder name',
  'file-management.fileLibrary.modal.createFolder.validation.tooLong':
    'Folder name must be 1-50 characters',
  'file-management.fileLibrary.modal.createFolder.validation.invalidCharacters':
    'Folder name cannot contain < > : " / \\ | ? *',
  'file-management.fileLibrary.modal.createFolder.validation.leadingOrTrailingDot':
    'Folder name cannot start or end with a dot',
  'file-management.fileLibrary.modal.createFolder.validation.consecutiveSpaces':
    'Folder name cannot contain consecutive spaces',
  'file-management.fileLibrary.modal.createFolder.validation.duplicate':
    'Folder with the same name already exists',
  'file-management.fileLibrary.modal.edit.title': 'Edit file info',
  'file-management.fileLibrary.modal.edit.nameLabel': 'File name',
  'file-management.fileLibrary.modal.edit.nameRequired':
    'Please enter file name',
  'file-management.fileLibrary.modal.edit.namePlaceholder':
    'Please enter file name',
  'file-management.fileLibrary.modal.edit.descriptionLabel': 'Description',
  'file-management.fileLibrary.modal.edit.descriptionPlaceholder':
    'Please enter file description',
  'file-management.fileLibrary.modal.edit.categoryLabel': 'Category',
  'file-management.fileLibrary.modal.edit.categoryPlaceholder':
    'Select category',
  'file-management.fileLibrary.modal.edit.category.document': 'Document',
  'file-management.fileLibrary.modal.edit.category.image': 'Image',
  'file-management.fileLibrary.modal.edit.category.video': 'Video',
  'file-management.fileLibrary.modal.edit.category.audio': 'Audio',
  'file-management.fileLibrary.modal.edit.category.other': 'Other',
  'file-management.fileLibrary.modal.edit.tagsLabel': 'Tags',
  'file-management.fileLibrary.modal.edit.tagsPlaceholder':
    'Enter tags and press Enter',
  'file-management.fileLibrary.modal.share.title': 'Share file',
  'file-management.fileLibrary.modal.share.fileName': 'File name',
  'file-management.fileLibrary.modal.share.expiresAt': 'Expires at',
  'file-management.fileLibrary.modal.share.link': 'Share link',
  'file-management.fileLibrary.modal.share.copyLink': 'Copy link',
  'file-management.fileLibrary.modal.share.close': 'Close',
  'file-management.fileLibrary.modal.upload.title': 'Upload file',
  'file-management.fileLibrary.modal.upload.needConfig':
    'Please select a storage config first',
  'file-management.fileLibrary.modal.bucket.title': 'Bucket management',
  'file-management.fileLibrary.confirm.download.title': 'Download file',
  'file-management.fileLibrary.confirm.download.content':
    'Are you sure you want to download this file?',
  'file-management.fileLibrary.confirm.deleteFolder.title': 'Delete folder',
  'file-management.fileLibrary.confirm.deleteFolder.content':
    'Are you sure you want to delete folder "{name}"?',
  'file-management.fileLibrary.confirm.deleteFolder.attention':
    'Important Reminder',
  'file-management.fileLibrary.confirm.deleteFolder.warning1':
    'Deleting this folder will permanently remove all its contents.',
  'file-management.fileLibrary.confirm.deleteFolder.warning2':
    'This action cannot be undone and may affect ongoing workflows.',
  'file-management.fileLibrary.confirm.deleteFolder.suggestion':
    'Please backup important files before proceeding with deletion.',
  'file-management.fileLibrary.confirm.deleteFile.question':
    'Are you sure you want to delete this file?',
  'file-management.fileLibrary.confirm.deleteFile.title': 'Delete file',
  'file-management.fileLibrary.confirm.deleteFile.warning':
    'This action cannot be undone.',
  'file-management.fileLibrary.confirm.forceDelete.content':
    'Folder "{name}" is not empty and contains:',
  'file-management.fileLibrary.confirm.forceDelete.subFolders':
    '{count} subfolder(s)',
  'file-management.fileLibrary.confirm.forceDelete.files': '{count} file(s)',
  'file-management.fileLibrary.confirm.forceDelete.attention':
    '⚠️ Critical Warning',
  'file-management.fileLibrary.confirm.forceDelete.warning1':
    'All files and subfolders within this folder will be permanently deleted.',
  'file-management.fileLibrary.confirm.forceDelete.warning2':
    'This operation cannot be undone and data recovery will be impossible.',
  'file-management.fileLibrary.confirm.forceDelete.warning3':
    'If other projects or team members depend on these files, they will be affected.',
  'file-management.fileLibrary.confirm.forceDelete.suggestion':
    'Consider creating a backup of important files before proceeding.',
  'file-management.fileLibrary.confirm.forceDelete.finalWarning':
    'Are you absolutely sure you want to proceed with this irreversible action?',
  'file-management.fileLibrary.confirm.forceDelete.confirm': 'Delete anyway',
  'file-management.fileLibrary.message.uploadFailedWithReason':
    'Upload failed: {reason}',
  'file-management.fileLibrary.message.bucketSwitched':
    'Switched to bucket {bucket}',
  'file-management.fileLibrary.message.checkFolderContentsFailed':
    'Failed to check folder contents',
  'file-management.fileLibrary.tree.context.delete': 'Delete',
  'file-management.fileLibrary.breadcrumb.currentFolder': 'Current folder',
  'file-management.fileLibrary.breadcrumb.minioStorage': 'MinIO Storage',
  'storage-config.modal.title.create': 'Create Storage Config',
  'storage-config.modal.title.edit': 'Edit Storage Config',
  'storage-config.modal.testConnection.button': 'Test Connection',
  'storage-config.modal.testConnection.failed': 'Connection test failed',
  'storage-config.modal.create.success': 'Storage config created successfully',
  'storage-config.modal.create.failed':
    'Failed to create storage config, please check configuration',
  'storage-config.modal.update.success': 'Storage config updated successfully',
  'storage-config.modal.templates.title': 'Quick Config Templates',
  'storage-config.modal.systemDefault.warning':
    'Storage quota and endpoint address of system default config cannot be modified, AccessKey and SecretKey are hidden',
  'storage-config.modal.form.configName.label': 'Config Name',
  'storage-config.modal.form.configName.required': 'Please enter config name',
  'storage-config.modal.form.configName.placeholder':
    'Please enter config name',
  'storage-config.modal.form.storageType.label': 'Storage Type',
  'storage-config.modal.form.storageType.required':
    'Please select storage type',
  'storage-config.modal.form.storageType.placeholder':
    'Please select storage type',
  'storage-config.modal.form.storageType.qiniu': 'Qiniu Cloud',
  'storage-config.modal.form.storageType.oss': 'Alibaba Cloud OSS',
  'storage-config.modal.form.description.label': 'Config Description',
  'storage-config.modal.form.description.placeholder':
    'Please enter config description (optional)',
  'storage-config.modal.form.endpoint.label': 'Endpoint Address',
  'storage-config.modal.form.endpoint.required':
    'Please enter endpoint address',
  'storage-config.modal.form.endpoint.placeholder':
    'e.g.: https://s3.amazonaws.com',
  'storage-config.modal.form.endpoint.extra.minio':
    'MinIO example: http://minio:9000 or http://localhost:9000',
  'storage-config.modal.form.endpoint.extra.s3':
    'AWS S3 example: https://s3.amazonaws.com',
  'storage-config.modal.form.region.label': 'Region',
  'storage-config.modal.form.region.placeholder': 'e.g.: us-east-1',
  'storage-config.modal.form.accessKey.label': 'accessKey',
  'storage-config.modal.form.accessKey.required': 'Please enter accessKey',
  'storage-config.modal.form.accessKey.placeholder': 'Please enter accessKey',
  'storage-config.modal.form.secretKey.label': 'secretKey',
  'storage-config.modal.form.secretKey.required': 'Please enter secretKey',
  'storage-config.modal.form.secretKey.placeholder': 'Please enter secretKey',
  'storage-config.modal.form.isAdminAccessKey.label': 'Admin Permission',
  'storage-config.modal.form.isAdminAccessKey.extra':
    'Enable to create new storage buckets with admin permission, no need to fill existing bucket name',
  'storage-config.modal.form.bucket.label': 'bucket',
  'storage-config.modal.form.bucket.required.normal':
    'Please enter storage bucket name',
  'storage-config.modal.form.bucket.required.admin':
    'Bucket name is optional with admin permission, leave empty to auto-create',
  'storage-config.modal.form.bucket.extra.normal':
    'Please enter existing storage bucket name',
  'storage-config.modal.form.bucket.extra.admin':
    'With admin permission, bucket name can be left empty, system will auto-create new bucket',
  'storage-config.modal.form.bucket.placeholder.normal':
    'Please enter storage bucket name',
  'storage-config.modal.form.bucket.placeholder.admin':
    'Leave empty to auto-create new bucket',
  'storage-config.modal.form.basePath.label': 'Base Path',
  'storage-config.modal.form.basePath.placeholder': 'e.g.: /files',
  'storage-config.modal.form.cdn.label': 'CDN Domain',
  'storage-config.modal.form.cdn.placeholder': 'e.g.: https://cdn.example.com',
  'storage-config.modal.form.storageQuota.label': 'Storage Quota',
  'storage-config.modal.form.storageQuota.required':
    'Please enter storage quota',
  'storage-config.modal.form.storageQuota.range':
    'Storage quota range is 100MB-50TB',
  'storage-config.modal.form.storageQuota.placeholder':
    'Please enter storage quota',
  'storage-config.modal.form.activateImmediately.label': 'Activate Immediately',
  'storage-config.modal.quotaRecommendation.title': 'Smart Recommendation',
  'storage-config.modal.quotaRecommendation.currentUsed': 'Current Usage',
  'storage-config.modal.quotaRecommendation.recommended': 'Recommended Quota',
  'storage-config.modal.quotaRecommendation.apply': 'Apply Recommendation',
  'upload.fileList.status.pending': 'Pending',
  'upload.fileList.status.uploading': 'Uploading',
  'upload.fileList.status.success': 'Success',
  'upload.fileList.status.error': 'Failed',
  'upload.fileList.renameHint':
    'Tip: You can modify the file name before uploading, the system will save it with the modified name. Modifications are only valid in pending status.',
  'upload.fileList.overallProgress': 'Overall Progress',
  'file-management.validation.sizeExceedsLimit':
    'File size exceeds the limit of {maxSize}MB',
  'file-management.uploadLimits.fileTypeNotRecognized':
    'File type not recognized',
  'file-management.uploadLimits.fileTypeNotAllowed':
    'File type not allowed. Allowed types: {types}',
  'file-management.loading.fromCache': 'From cache',
  // Upload Center Page
  'file-management.uploadCenter.pageTitle': 'Upload Center',
  'file-management.uploadCenter.pageDescription':
    'Upload files, manage tasks, view progress',
  'file-management.uploadCenter.status.connected': '{name} Connected',
  'file-management.uploadCenter.status.disconnected': '{name} Disconnected',
  'file-management.uploadCenter.card.upload.title': 'File Upload',
  'file-management.uploadCenter.label.selectFolder': 'Select Upload Folder',
  'file-management.uploadCenter.dragger.text':
    'Click or drag files to this area to upload',
  'file-management.uploadCenter.dragger.hint':
    'Support single or batch file upload',
  'file-management.uploadCenter.card.tasks.title': 'Upload Tasks',
  'file-management.uploadCenter.empty.noTasks': 'No upload tasks',
  'file-management.uploadCenter.button.clearCompleted': 'Clear Completed',
  'file-management.uploadCenter.action.pause': 'Pause',
  'file-management.uploadCenter.action.resume': 'Resume',
  'file-management.uploadCenter.action.retry': 'Retry',
  'file-management.uploadCenter.action.cancel': 'Cancel',
  'file-management.uploadCenter.status.pending': 'Pending',
  'file-management.uploadCenter.status.uploading': 'Uploading',
  'file-management.uploadCenter.status.paused': 'Paused',
  'file-management.uploadCenter.status.completed': 'Completed',
  'file-management.uploadCenter.status.error': 'Error',
  'file-management.uploadCenter.task.calculating': 'Calculating...',
  'file-management.uploadCenter.task.completed': 'Completed',
  'file-management.uploadCenter.task.remaining': '{seconds}s remaining',
  'file-management.uploadCenter.task.uploadFailed': 'Upload failed',
  'file-management.uploadCenter.label.currentStorage': 'Current Storage',
  'file-management.uploadCenter.label.bucket': 'Bucket',
  'file-management.uploadCenter.label.region': 'Region',
  'file-management.uploadCenter.empty.noStorageConfig':
    'No storage configuration',
  'file-management.uploadCenter.button.goToConfig': 'Go to Config',
  'file-management.uploadCenter.empty.pleaseSelectStorage':
    'Please select storage configuration',
  'file-management.uploadCenter.placeholder.selectStorage':
    'Select storage configuration',
  'file-management.uploadCenter.message.cleared': 'Completed tasks cleared',
  // Direct Upload Component
  'file-management.directUpload.title': 'Direct Upload',
  'file-management.directUpload.selectFiles': 'Click or drag to select files',
  'file-management.directUpload.selectFilesOnly': 'Click to select files',
  'file-management.directUpload.multiFileSupport':
    'Supports multiple file upload',
  'file-management.directUpload.dragDropDisabled': ' (Drag & drop disabled)',
  'file-management.directUpload.loadingConfig': 'Loading configuration...',
  'file-management.directUpload.configLoadFailed':
    'Failed to load config: {error}',
  'file-management.directUpload.configNotLoaded':
    'Config not fully loaded, using default limits (max {count} files)',
  'file-management.directUpload.startUpload': 'Start Upload ({count})',
  'file-management.directUpload.clear': 'Clear List',
  'file-management.directUpload.instructions.title': 'Instructions',
  'file-management.directUpload.instructions.step1':
    'Click the area above or drag files here to select',
  'file-management.directUpload.instructions.step2':
    'Supports batch upload of multiple files',
  'file-management.directUpload.instructions.step3':
    'You can rename files before uploading',
  'file-management.directUpload.instructions.step4':
    'Click "Start Upload" button to start uploading',
  'file-management.directUpload.message.uploadFailed': 'Upload failed',
  'file-management.directUpload.message.validationFailed':
    '{count} files failed validation: {files}{more}',
  'file-management.directUpload.message.moreFiles': ' and {count} more',
  'file-management.directUpload.message.addSuccess':
    'Successfully added {count} files',
  'file-management.directUpload.message.noPendingFiles':
    'No pending files to upload',
  'file-management.directUpload.message.emptyFileName':
    'File name cannot be empty',
  'file-management.directUpload.message.uploadSuccess':
    'File "{filename}" uploaded successfully',
  'file-management.directUpload.message.batchUploadComplete':
    'All files uploaded successfully',
  'file-management.directUpload.message.partialSuccess':
    'Some files failed to upload: {errors}{more}',
  'file-management.directUpload.message.allFailed':
    'All files failed to upload: {errors}{more}',
  'file-management.directUpload.message.batchUploadFailed':
    'Batch upload failed',
  'file-management.directUpload.message.fileInfoIncomplete':
    'File information incomplete',
  'file-management.directUpload.message.getDownloadLinkFailed':
    'Failed to get download link',
  'file-management.directUpload.message.downloadFailed': 'Download failed',
  // Upload File List Component
  'upload.fileList.download': 'Download',
  'upload.fileList.delete': 'Delete',
  'upload.fileList.fileNamePlaceholder': 'Enter file name',
  'upload.fileList.renamed': 'Renamed',
  'upload.fileList.originalName': 'Original',
  'upload.fileList.speed': 'Speed',
  'upload.fileList.remaining': 'Remaining',
  'upload.fileList.uploadSuccess': 'Upload successful',
  'upload.fileList.uploadFailed': 'Upload failed',
  'upload.fileList.waiting': 'Waiting to upload',
  'upload.fileList.time.second': 's',
  'upload.fileList.time.minute': 'm',
  'upload.fileList.time.hour': 'h',
  // File Validation
  'file-management.validation.noTypeRestriction': 'All file types allowed',
  'file-management.validation.allowedTypes': 'Allowed file types: {types}',
  'file-management.validation.noSizeLimit': 'No file size limit',
  'file-management.validation.maxFileSize': 'Max file size: {size}MB',
  // Upload Limits
  'file-management.uploadLimits.fileCountExceedsLimit':
    'File count exceeds limit, max {maxFiles} files allowed',
  'file-management.uploadLimits.configNotLoaded': 'Config loading...',
  'file-management.uploadLimits.description':
    'Max {maxSize}MB, {maxFiles} files per batch',
  // Storage Config Management Page
  'file-management.storageConfig.pageDescription':
    'Manage external cloud storage configurations, supporting multiple storage services',
  'file-management.storageConfig.button.create': 'Create Config',
  'file-management.storageConfig.button.refresh': 'Refresh',
  'file-management.storageConfig.delete.confirmTitle': 'Confirm Delete',
  'file-management.storageConfig.delete.confirmContent':
    'Are you sure you want to delete storage config "{name}"? This action cannot be undone.',
  'file-management.storageConfig.action.test': 'Test Connection',
  'file-management.storageConfig.action.edit': 'Edit',
  'file-management.storageConfig.action.setDefault': 'Set Default',
  'file-management.storageConfig.action.unsetDefault': 'Unset Default',
  'file-management.storageConfig.action.delete': 'Delete',
  'file-management.storageConfig.status.admin': 'Admin',
  'file-management.storageConfig.status.active': 'Active',
  // Storage Config Table Columns
  'file-management.storageConfig.table.column.name': 'Config Name',
  'file-management.storageConfig.table.column.type': 'Storage Type',
  'file-management.storageConfig.table.column.endpoint': 'Endpoint',
  'file-management.storageConfig.table.column.bucket': 'Bucket',
  'file-management.storageConfig.table.column.createdAt': 'Created At',
  'file-management.storageConfig.table.column.status': 'Status',
  'file-management.storageConfig.table.column.actions': 'Actions',
  // Storage Config Form
  'file-management.storageConfig.modal.create.title': 'Create Storage Config',
  'file-management.storageConfig.modal.edit.title': 'Edit Storage Config',
  'file-management.storageConfig.form.label.configName': 'Config Name',
  'file-management.storageConfig.form.placeholder.configName':
    'Please enter config name',
  'file-management.storageConfig.form.label.storageType': 'Storage Type',
  'file-management.storageConfig.form.placeholder.storageType':
    'Please select storage type',
  'file-management.storageConfig.form.label.endpoint': 'Endpoint',
  'file-management.storageConfig.form.placeholder.endpoint':
    'Please enter endpoint',
  'file-management.storageConfig.form.label.bucket': 'Bucket',
  'file-management.storageConfig.form.placeholder.bucket':
    'Please enter bucket name',
  'file-management.storageConfig.form.label.region': 'Region',
  'file-management.storageConfig.form.placeholder.region':
    'Please enter region (optional)',
  'file-management.storageConfig.form.label.accessKey': 'Access Key',
  'file-management.storageConfig.form.placeholder.accessKey':
    'Please enter Access Key',
  'file-management.storageConfig.form.label.secretKey': 'Secret Key',
  'file-management.storageConfig.form.placeholder.secretKey':
    'Please enter Secret Key',
  'file-management.storageConfig.form.placeholder.secretKeyEdit':
    'Leave blank to keep unchanged',
  'file-management.storageConfig.form.label.basePath': 'Base Path',
  'file-management.storageConfig.form.placeholder.basePath':
    'Please enter base path (optional)',
  'file-management.storageConfig.form.label.cdn': 'CDN Domain',
  'file-management.storageConfig.form.placeholder.cdn':
    'Please enter CDN domain (optional)',
  'file-management.storageConfig.form.label.storageQuotaValue': 'Storage Quota',
  'file-management.storageConfig.form.placeholder.storageQuotaValue':
    'Please enter storage quota',
  'file-management.storageConfig.form.label.storageQuotaUnit': 'Unit',
  'file-management.storageConfig.form.placeholder.storageQuotaUnit':
    'Please select unit',
  'file-management.storageConfig.form.label.isDefault': 'Set as Default',
  'file-management.storageConfig.form.label.isAdminAccessKey': 'Admin Access',
  // Storage Config Alerts
  'file-management.storageConfig.alert.storageTypeTips':
    '{type} Configuration Tips',
  'file-management.storageConfig.alert.minioDescription':
    'MinIO is a high-performance object storage system compatible with Amazon S3 API. Please ensure the endpoint address is accessible and configure Access Key and Secret Key correctly.',
  'file-management.storageConfig.alert.s3Description':
    'AWS S3 is an object storage service provided by Amazon. Please ensure your account has permission to access the specified bucket and configure the region information correctly.',
  'file-management.storageConfig.alert.ossDescription':
    'Alibaba Cloud OSS is an object storage service provided by Alibaba Cloud. Please ensure your account has permission to access the specified bucket and configure Endpoint and region information correctly.',
  'file-management.storageConfig.alert.qiniuDescription':
    'Qiniu Cloud Storage is an object storage service provided by Qiniu. Please ensure your account has permission to access the specified bucket and configure Access Key and Secret Key correctly.',
  'file-management.storageConfig.form.tooltip.isAdminAccessKey':
    'Enable admin access to use admin Access Key with advanced permissions such as creating buckets',
  // Bucket Management
  'file-management.bucketManagement.title': 'Bucket Management',
  'file-management.bucketManagement.refresh': 'Refresh',
  'file-management.bucketManagement.create': 'Create Bucket',
  'file-management.bucketManagement.switch': 'Switch',
  'file-management.bucketManagement.switchTo': 'Switch to this bucket',
  'file-management.bucketManagement.delete': 'Delete',
  'file-management.bucketManagement.current': 'Current',
  'file-management.bucketManagement.permissionDenied': 'Permission Denied',
  'file-management.bucketManagement.permissionDeniedDesc':
    'You need admin access to manage buckets. Please enable "Admin Access" in the storage config.',
  'file-management.bucketManagement.column.name': 'Bucket Name',
  'file-management.bucketManagement.column.creationDate': 'Creation Date',
  'file-management.bucketManagement.column.region': 'Region',
  'file-management.bucketManagement.column.actions': 'Actions',
  'file-management.bucketManagement.confirm.delete.title': 'Delete Bucket',
  'file-management.bucketManagement.confirm.delete.description':
    'This operation will delete the bucket and all its contents. Please confirm carefully.',
  'file-management.bucketManagement.message.createSuccess':
    'Bucket created successfully',
  'file-management.bucketManagement.message.switchSuccess':
    'Bucket switched successfully',
  'file-management.bucketManagement.message.deleteSuccess':
    'Bucket deleted successfully',
  'file-management.bucketManagement.modal.create.title': 'Create Bucket',
  'file-management.bucketManagement.modal.create.bucketName': 'Bucket Name',
  'file-management.bucketManagement.modal.create.bucketNameRequired':
    'Please enter bucket name',
  'file-management.bucketManagement.modal.create.bucketNameLength':
    'Bucket name must be 3-63 characters',
  'file-management.bucketManagement.modal.create.bucketNamePattern':
    'Bucket name can only contain lowercase letters, numbers, dots, and hyphens',
  'file-management.bucketManagement.modal.create.bucketNameStartEnd':
    'Bucket name cannot start or end with a dot or hyphen',
  'file-management.bucketManagement.modal.create.bucketNameConsecutive':
    'Bucket name cannot contain consecutive dots or hyphens',
  'file-management.bucketManagement.modal.create.bucketNameIP':
    'Bucket name cannot be in IP address format',
  'file-management.bucketManagement.modal.create.bucketNamePrefix':
    'Bucket name cannot start with reserved prefixes (xn--, sthree-, s3alias)',
  'file-management.bucketManagement.modal.create.bucketNamePlaceholder':
    'Enter bucket name (3-63 characters)',
  'file-management.bucketManagement.modal.create.region': 'Region',
  'file-management.bucketManagement.modal.create.accessControl':
    'Access Control',
  'file-management.bucketManagement.modal.create.accessControl.private':
    'Private',
  'file-management.bucketManagement.modal.create.accessControl.publicRead':
    'Public Read',
  'file-management.bucketManagement.modal.create.accessControl.publicReadWrite':
    'Public Read/Write',
  'file-management.bucketManagement.modal.switch.title': 'Switch Bucket',
  'file-management.bucketManagement.modal.switch.message':
    'Switch Current Bucket',
  'file-management.bucketManagement.modal.switch.description':
    'After switching, new files will be uploaded to the selected bucket. Existing files will not be affected.',
  'file-management.bucketManagement.modal.switch.selectBucket': 'Select Bucket',
  'file-management.bucketManagement.modal.switch.bucketRequired':
    'Please select a bucket',
  'file-management.bucketManagement.modal.switch.selectBucketPlaceholder':
    'Select a bucket',
  'file-management.bucketManagement.modal.delete.title': 'Delete Bucket',
  'file-management.bucketManagement.modal.delete.message':
    'Delete Bucket Warning',
  'file-management.bucketManagement.modal.delete.description':
    'This operation will permanently delete the bucket and all its contents. Please proceed with caution.',
  'file-management.bucketManagement.modal.delete.bucketName': 'Bucket Name',
  'file-management.bucketManagement.modal.delete.forceDelete': 'Force Delete',
  'file-management.bucketManagement.modal.delete.forceDeleteExtra':
    'Force delete will remove all files in the bucket',
  'file-management.bucketManagement.modal.delete.forceDeleteNo':
    'No (only delete empty bucket)',
  'file-management.bucketManagement.modal.delete.forceDeleteYes':
    'Yes (delete bucket and all files)',
  'file-management.bucketManagement.modal.delete.confirm': 'Confirm Delete',
  // Missing translation keys - Create Folder
  'file-management.createFolder.title': 'Create Folder',
  'file-management.createFolder.folderName': 'Folder Name',
  'file-management.createFolder.folderNamePlaceholder': 'Enter folder name',
  'file-management.createFolder.storageConfig': 'Storage Config',
  'file-management.createFolder.storageConfigPlaceholder':
    'Select storage config (optional)',
  'file-management.createFolder.hint.defaultConfig':
    'If not selected, default config will be used',
  'file-management.createFolder.hint.namingRules':
    'Avoid special characters and duplicate names',
  'file-management.createFolder.create': 'Create',
  'file-management.createFolder.cancel': 'Cancel',
  // Missing translation keys - Download Manager
  'file-management.downloadManager.title': 'Download Manager',
  'file-management.downloadManager.noTasks': 'No download tasks',
  'file-management.downloadManager.progress': 'Progress',
  'file-management.downloadManager.duration': 'Duration',
  'file-management.downloadManager.error': 'Error',
  'file-management.downloadManager.action.pause': 'Pause',
  'file-management.downloadManager.action.resume': 'Resume',
  'file-management.downloadManager.action.cancel': 'Cancel',
  'file-management.downloadManager.action.retry': 'Retry',
  'file-management.downloadManager.status.pending': 'Pending',
  'file-management.downloadManager.status.downloading': 'Downloading',
  'file-management.downloadManager.status.paused': 'Paused',
  'file-management.downloadManager.status.completed': 'Completed',
  'file-management.downloadManager.status.error': 'Error',
  'file-management.downloadManager.status.unknown': 'Unknown',
  // Missing translation keys - Empty State
  'file-management.emptyState.title': 'No Data',
  'file-management.emptyState.subtitle': 'Start managing your files',
  'file-management.emptyState.noConfig.title': 'No Storage Configured',
  'file-management.emptyState.noConfig.description':
    'You need to configure storage service to use file management',
  'file-management.emptyState.noConfig.createConfig': 'Create Config',
  'file-management.emptyState.noConfig.createDefault': 'Create Default Config',
  'file-management.emptyState.noSelectedConfig.title':
    'No Storage Config Selected',
  'file-management.emptyState.noSelectedConfig.description':
    'Please select a storage config to start managing files',
  'file-management.emptyState.noSelectedConfig.selectConfig': 'Select Config',
  'file-management.emptyState.noSelectedConfig.manageConfig': 'Manage Config',
  'file-management.emptyState.notConnected.title':
    'Storage Service Not Connected',
  'file-management.emptyState.notConnected.description':
    'Cannot connect to storage service, please check configuration',
  'file-management.emptyState.notConnected.hint':
    'Hint: Check network connection and storage service status',
  'file-management.emptyState.notConnected.benefit':
    'Use cloud storage to safely save and manage your files',
  'file-management.emptyState.notConnected.configure': 'Configure Storage',
  'file-management.emptyState.notConnected.manage': 'Manage Storage',
  // Missing translation keys - Fields
  'file-management.field.description': 'Description',
  'file-management.field.category': 'Category',
  'file-management.field.visibility': 'Visibility',
  'file-management.field.originalName': 'Original File Name',
  'file-management.visibility.private': 'Personal',
  'file-management.visibility.organization': 'Organization',
  'file-management.visibility.tenant': 'Tenant Public',
  'file-management.scope.private.title': 'Personal Files',
  'file-management.scope.organization.title': 'Organization Files',
  'file-management.scope.tenant.title': 'Tenant Public Files',
  'file-management.scope.private.hint':
    'Personal files are only visible and manageable by the owner; owner/admin may still intervene for enterprise administration.',
  'file-management.scope.organization.hint':
    'Organization files can be viewed, uploaded, renamed, moved, and deleted by members in the same organization.',
  'file-management.scope.tenant.hint.admin':
    'Tenant public files can be viewed and downloaded by everyone in the tenant; you can also upload and manage them.',
  'file-management.scope.tenant.hint.member':
    'Tenant public files are view/download only for you; upload and modification are limited to owner/admin.',
  // Missing translation keys - File Edit
  'file-management.fileEdit.title': 'Edit File',
  'file-management.fileEdit.fileName': 'File Name',
  'file-management.fileEdit.fileNamePlaceholder': 'Enter file name',
  'file-management.fileEdit.fileNameRequired': 'Please enter file name',
  'file-management.fileEdit.fileNameMaxLength':
    'File name cannot exceed 100 characters',
  'file-management.fileEdit.description': 'Description',
  'file-management.fileEdit.descriptionPlaceholder': 'Enter file description',
  'file-management.fileEdit.descriptionMaxLength':
    'Description cannot exceed 500 characters',
  'file-management.fileEdit.category': 'Category',
  'file-management.fileEdit.categoryPlaceholder': 'Select category',
  'file-management.fileEdit.categoryRequired': 'Please select a category',
  'file-management.fileEdit.category.document': 'Document',
  'file-management.fileEdit.category.image': 'Image',
  'file-management.fileEdit.category.video': 'Video',
  'file-management.fileEdit.category.audio': 'Audio',
  'file-management.fileEdit.category.archive': 'Archive',
  'file-management.fileEdit.category.other': 'Other',
  'file-management.fileEdit.tags': 'Tags',
  'file-management.fileEdit.tagsPlaceholder': 'Enter tags and press Enter',
  'file-management.fileEdit.tagsExtra': 'Add tags to better organize files',
  'file-management.fileEdit.save': 'Save',
  'file-management.fileEdit.cancel': 'Cancel',
  // Missing translation keys - File List Table
  'file-management.fileListTable.column.name': 'Name',
  'file-management.fileListTable.column.size': 'Size',
  'file-management.fileListTable.column.lastModified': 'Last Modified',
  'file-management.fileListTable.column.author': 'Author',
  'file-management.fileListTable.column.tags': 'Tags',
  'file-management.fileListTable.column.action': 'Action',
  'file-management.fileListTable.search.placeholder': 'Search files...',
  'file-management.fileListTable.filter.fileType.placeholder': 'File Type',
  'file-management.fileListTable.filter.fileType.pdf': 'PDF',
  'file-management.fileListTable.filter.fileType.docx': 'Word',
  'file-management.fileListTable.filter.fileType.xlsx': 'Excel',
  'file-management.fileListTable.filter.fileType.psd': 'PSD',
  'file-management.fileListTable.filter.more': 'More Filters',
  'file-management.fileListTable.refresh': 'Refresh',
  'file-management.fileListTable.pagination.showTotal': 'Total {total} items',
  // Missing translation keys - File Preview
  'file-management.filePreview.title': 'File Preview',
  'file-management.filePreview.close': 'Close',
  'file-management.filePreview.download': 'Download',
  'file-management.filePreview.fullscreen': 'Fullscreen',
  'file-management.filePreview.openInNewWindow': 'Open in New Window',
  'file-management.filePreview.notSupported': 'Unsupported File Type',
  'file-management.filePreview.notSupportedDesc':
    'This file type is not supported for preview, please download to view',
  'file-management.filePreview.unsupportedType': 'Unsupported Type',
  'file-management.filePreview.unsupportedTypeDesc':
    'Cannot preview this type of file',
  'file-management.filePreview.failed': 'Preview Failed',
  'file-management.filePreview.generating': 'Generating preview...',
  'file-management.filePreview.generateFailed': 'Failed to generate preview',
  'file-management.filePreview.getInfoFailed': 'Failed to get file info',
  'file-management.filePreview.imageLoadFailed': 'Failed to load image',
  'file-management.filePreview.pdfLoadFailed': 'Failed to load PDF',
  'file-management.filePreview.audioLoadFailed': 'Failed to load audio',
  'file-management.filePreview.videoLoadFailed': 'Failed to load video',
  'file-management.filePreview.textLoadFailed': 'Failed to load text',
  'file-management.filePreview.browserNotSupportAudio':
    'Your browser does not support audio playback',
  'file-management.filePreview.browserNotSupportVideo':
    'Your browser does not support video playback',
  'file-management.filePreview.officePreview': 'Office Preview',
  'file-management.filePreview.officeDesc1':
    'Office documents will open in a new window',
  'file-management.filePreview.officeDesc2':
    'Please ensure pop-ups are allowed',
  // Missing translation keys - Folder Tree
  'file-management.folderTree.root': 'Root',
  'file-management.folderTree.files': 'Files',
  'file-management.folderTree.subFolders': 'Subfolders',
  // Missing translation keys - Loading
  'file-management.loading.loading': 'Loading...',
  'file-management.loading.loadingData': 'Loading data...',
  // Missing translation keys - Messages
  'file-management.message.configCreated': 'Config created successfully',
  'file-management.message.configUpdated': 'Config updated successfully',
  'file-management.message.configDeleted': 'Config deleted successfully',
  'file-management.message.connectionSuccess': 'Connection successful',
  'file-management.message.connectionFailed': 'Connection failed',
  'file-management.message.saveConfigFailed': 'Failed to save config',
  'file-management.message.deleteConfigFailed': 'Failed to delete config',
  'file-management.message.defaultConfigSet': 'Set as default config',
  'file-management.message.defaultConfigUnset': 'Unset default config',
  'file-management.message.toggleDefaultFailed':
    'Failed to toggle default config',
  'file-management.message.officeDocumentOpened':
    'Office document opened in new window',
  // Missing translation keys - Share File
  'file-management.shareFile.title': 'Share File',
  'file-management.shareFile.fileName': 'File Name',
  'file-management.shareFile.shareLink': 'Share Link',
  'file-management.shareFile.expiresAt': 'Expires At',
  'file-management.shareFile.copyLink': 'Copy Link',
  // Missing translation keys - Storage Config Delete
  'file-management.storageConfig.delete.okText': 'Delete',
  'file-management.storageConfig.delete.cancelText': 'Cancel',
  'file-management.storageConfig.delete.warning':
    'Warning: This action cannot be undone',
  // Missing translation keys - Storage Config Form Validation
  'file-management.storageConfig.form.validation.configNameRequired':
    'Please enter config name',
  'file-management.storageConfig.form.validation.storageTypeRequired':
    'Please select storage type',
  'file-management.storageConfig.form.validation.endpointRequired':
    'Please enter endpoint',
  'file-management.storageConfig.form.validation.accessKeyRequired':
    'Please enter Access Key',
  'file-management.storageConfig.form.validation.secretKeyRequired':
    'Please enter Secret Key',
  'file-management.storageConfig.form.validation.bucketRequired':
    'Please enter bucket name',
  'file-management.storageConfig.form.validation.storageQuotaValueRequired':
    'Please enter storage quota',
  'file-management.storageConfig.form.validation.storageQuotaUnitRequired':
    'Please select storage quota unit',
  // Missing translation keys - Storage Config Detail
  'file-management.storageConfigDetail.title': 'Storage Config Detail',
  'file-management.storageConfigDetail.basicInfo': 'Basic Info',
  'file-management.storageConfigDetail.configName': 'Config Name',
  'file-management.storageConfigDetail.storageType': 'Storage Type',
  'file-management.storageConfigDetail.endpoint': 'Endpoint',
  'file-management.storageConfigDetail.bucket': 'Bucket',
  'file-management.storageConfigDetail.region': 'Region',
  'file-management.storageConfigDetail.basePath': 'Base Path',
  'file-management.storageConfigDetail.cdn': 'CDN Domain',
  'file-management.storageConfigDetail.quota': 'Storage Quota',
  'file-management.storageConfigDetail.status': 'Status',
  'file-management.storageConfigDetail.status.default': 'Default',
  'file-management.storageConfigDetail.status.active': 'Active',
  'file-management.storageConfigDetail.status.inactive': 'Inactive',
  'file-management.storageConfigDetail.status.currentActive': 'Current Active',
  'file-management.storageConfigDetail.createdAt': 'Created At',
  'file-management.storageConfigDetail.lastSync': 'Last Sync',
  'file-management.storageConfigDetail.usageStats': 'Usage Statistics',
  'file-management.storageConfigDetail.totalFiles': 'Total Files',
  'file-management.storageConfigDetail.totalSize': 'Total Size',
  'file-management.storageConfigDetail.used': 'Used',
  'file-management.storageConfigDetail.usedLabel': 'Used',
  'file-management.storageConfigDetail.remainingLabel': 'Remaining',
  'file-management.storageConfigDetail.usageRate': 'Usage Rate',
  'file-management.storageConfigDetail.healthStatus': 'Health Status',
  'file-management.storageConfigDetail.healthy': 'Healthy',
  'file-management.storageConfigDetail.unhealthy': 'Unhealthy',
  'file-management.storageConfigDetail.accessible': 'Accessible',
  'file-management.storageConfigDetail.notAccessible': 'Not Accessible',
  'file-management.storageConfigDetail.notSet': 'Not Set',
  'file-management.storageConfigDetail.notSynced': 'Not Synced',
  'file-management.storageConfigDetail.checkStatus': 'Check Status',
  'file-management.storageConfigDetail.cleanup': 'Cleanup Storage',
  'file-management.storageConfigDetail.cleanupSuccess': 'Cleanup successful',
  'file-management.storageConfigDetail.cleanupFailed': 'Cleanup failed',
  'file-management.storageConfigDetail.loadFailed': 'Failed to load details',
  'file-management.storageConfigDetail.actions': 'Actions',
  'file-management.storageConfig.systemDefault.hidden':
    'System config (hidden)',
  'file-management.storageConfig.action.view': 'View',
  'file-management.storageConfig.modal.view.title': 'View Storage Config',
  'file-management.storageConfig.table.column.usage': 'Storage Usage',
  // Missing translation keys - Storage Expansion
  'file-management.storageExpansion.title': 'Storage Expansion',
  'file-management.storageExpansion.selectCapacity.title': 'Select Capacity',
  'file-management.storageExpansion.selectCapacity.currentUsage':
    'Current Usage',
  'file-management.storageExpansion.selectCapacity.selectLabel':
    'Select Expansion Capacity',
  'file-management.storageExpansion.selectCapacity.custom': 'Custom',
  'file-management.storageExpansion.selectCapacity.customLabel':
    'Custom Capacity',
  'file-management.storageExpansion.selectCapacity.customFlexible':
    'Flexibly choose the capacity you need',
  'file-management.storageExpansion.selectCapacity.expandedTotal':
    'Total Capacity After Expansion',
  'file-management.storageExpansion.selectCapacity.price': 'Price',
  'file-management.storageExpansion.selectCapacity.warning':
    'Note: Capacity cannot be reduced after expansion',
  'file-management.storageExpansion.selectCapacity.next': 'Next',
  'file-management.storageExpansion.selectCapacity.cancel': 'Cancel',
  'file-management.storageExpansion.selectCapacity.capacityValue':
    'Capacity Value',
  'file-management.storageExpansion.payment.title': 'Payment',
  'file-management.storageExpansion.payment.method': 'Payment Method',
  'file-management.storageExpansion.payment.methodRequired':
    'Please select payment method',
  'file-management.storageExpansion.payment.alipay': 'Alipay',
  'file-management.storageExpansion.payment.wechat': 'WeChat Pay',
  'file-management.storageExpansion.payment.bank': 'Bank Transfer',
  'file-management.storageExpansion.payment.paymentAmount': 'Payment Amount',
  'file-management.storageExpansion.payment.previous': 'Previous',
  'file-management.storageExpansion.payment.confirm': 'Confirm Payment',
  'file-management.storageExpansion.payment.expansionCapacity':
    'Expansion Capacity',
  'file-management.storageExpansion.payment.expandedTotal':
    'Total Capacity After Expansion',
  'file-management.storageExpansion.success.title': 'Expansion Successful',
  'file-management.storageExpansion.success.message':
    'Your storage space has been successfully expanded',
  'file-management.storageExpansion.success.thanks':
    'Thank you for using our service',
  'file-management.storageExpansion.message.success':
    'Storage expansion successful',
  'file-management.storageExpansion.message.paymentFailed':
    'Payment failed, please retry',
  // Missing translation keys - Storage Quota Recommendation
  'file-management.storageQuota.recommendation.smallUsage': 'Small usage',
  'file-management.storageQuota.recommendation.oneGB': '1 GB',
  'file-management.storageQuota.recommendation.twoGB': '2 GB',
  'file-management.storageQuota.recommendation.fiveGB': '5 GB',
  'file-management.storageQuota.recommendation.tenGB': '10 GB',
  'file-management.storageQuota.recommendation.twentyGB': '20 GB',
  'file-management.storageQuota.recommendation.fiftyGB': '50 GB',
  'file-management.storageQuota.recommendation.hundredGB': '100 GB',
  'file-management.storageQuota.recommendation.twoHundredGB': '200 GB',
  'file-management.storageQuota.recommendation.custom': 'Custom',
  // Storage Quota Display
  'file-management.storageQuota.title': 'Storage Quota',
  'file-management.storageQuota.used': 'Used',
  'file-management.storageQuota.totalQuota': 'Total Quota',
  'file-management.storageQuota.remaining': 'Remaining',
  'file-management.storageQuota.warning.critical':
    'Storage space critically low',
  'file-management.storageQuota.warning.high': 'Storage usage is high',
  'file-management.storageQuota.status.sufficient': 'Sufficient',
  'file-management.storageQuota.status.tight': 'Tight',
  'file-management.storageQuota.status.critical': 'Critical',
  'file-management.storageQuota.status.adequate': 'Adequate',
  'file-management.storageQuota.status.insufficient': 'Insufficient',
  'file-management.storageQuota.validation.mustBeGreaterThanZero':
    'Must be greater than zero',
  'file-management.storageQuota.validation.cannotBeLessThan':
    'Cannot be less than {min}',
  'file-management.storageQuota.validation.cannotBeGreaterThan':
    'Cannot be greater than {max}',
  // File type translations
  // Document types
  'file-management.fileTypes.pdf': 'PDF Document',
  'file-management.fileTypes.doc': 'Word Document',
  'file-management.fileTypes.docx': 'Word Document',
  'file-management.fileTypes.xls': 'Excel Spreadsheet',
  'file-management.fileTypes.xlsx': 'Excel Spreadsheet',
  'file-management.fileTypes.ppt': 'PowerPoint Presentation',
  'file-management.fileTypes.pptx': 'PowerPoint Presentation',
  'file-management.fileTypes.txt': 'Text File',
  'file-management.fileTypes.md': 'Markdown Document',
  'file-management.fileTypes.rtf': 'RTF Document',
  'file-management.fileTypes.csv': 'CSV Data',
  'file-management.fileTypes.epub': 'EPUB eBook',
  'file-management.fileTypes.eml': 'Email File',
  // Image types
  'file-management.fileTypes.jpg': 'JPEG Image',
  'file-management.fileTypes.jpeg': 'JPEG Image',
  'file-management.fileTypes.png': 'PNG Image',
  'file-management.fileTypes.gif': 'GIF Image',
  'file-management.fileTypes.bmp': 'BMP Image',
  'file-management.fileTypes.webp': 'WebP Image',
  'file-management.fileTypes.svg': 'SVG Vector',
  'file-management.fileTypes.tiff': 'TIFF Image',
  'file-management.fileTypes.tif': 'TIFF Image',
  'file-management.fileTypes.ico': 'ICO Icon',
  // Code types
  'file-management.fileTypes.js': 'JavaScript',
  'file-management.fileTypes.ts': 'TypeScript',
  'file-management.fileTypes.py': 'Python',
  'file-management.fileTypes.java': 'Java',
  'file-management.fileTypes.c': 'C',
  'file-management.fileTypes.cpp': 'C++',
  'file-management.fileTypes.cs': 'C#',
  'file-management.fileTypes.go': 'Go',
  'file-management.fileTypes.rs': 'Rust',
  'file-management.fileTypes.php': 'PHP',
  'file-management.fileTypes.rb': 'Ruby',
  'file-management.fileTypes.swift': 'Swift',
  'file-management.fileTypes.kt': 'Kotlin',
  'file-management.fileTypes.scala': 'Scala',
  'file-management.fileTypes.sh': 'Shell Script',
  'file-management.fileTypes.bash': 'Bash Script',
  'file-management.fileTypes.ps1': 'PowerShell Script',
  'file-management.fileTypes.bat': 'Batch File',
  'file-management.fileTypes.cmd': 'Command File',
  'file-management.fileTypes.html': 'HTML File',
  'file-management.fileTypes.htm': 'HTML File',
  'file-management.fileTypes.css': 'CSS Stylesheet',
  'file-management.fileTypes.json': 'JSON Data',
  'file-management.fileTypes.xml': 'XML File',
  'file-management.fileTypes.yaml': 'YAML Config',
  'file-management.fileTypes.yml': 'YAML Config',
  'file-management.fileTypes.properties': 'Properties Config',
  // Audio types
  'file-management.fileTypes.mp3': 'MP3 Audio',
  'file-management.fileTypes.wav': 'WAV Audio',
  'file-management.fileTypes.ogg': 'OGG Audio',
  'file-management.fileTypes.aac': 'AAC Audio',
  'file-management.fileTypes.flac': 'FLAC Audio',
  'file-management.fileTypes.m4a': 'M4A Audio',
  'file-management.fileTypes.wma': 'WMA Audio',
  // Video types
  'file-management.fileTypes.mp4': 'MP4 Video',
  'file-management.fileTypes.avi': 'AVI Video',
  'file-management.fileTypes.mov': 'MOV Video',
  'file-management.fileTypes.wmv': 'WMV Video',
  'file-management.fileTypes.webm': 'WebM Video',
  'file-management.fileTypes.mkv': 'MKV Video',
  'file-management.fileTypes.3gp': '3GP Video',
  // Archive types
  'file-management.fileTypes.zip': 'ZIP Archive',
  'file-management.fileTypes.rar': 'RAR Archive',
  'file-management.fileTypes.7z': '7Z Archive',
  'file-management.fileTypes.tar': 'TAR Archive',
  'file-management.fileTypes.gz': 'GZ Archive',
  'file-management.fileTypes.bz2': 'BZ2 Archive',
  'file-management.fileTypes.dmg': 'DMG Disk Image',
  'file-management.fileTypes.iso': 'ISO Image',
  'file-management.fileTypes.xz': 'XZ Archive',
  // Database types
  'file-management.fileTypes.sql': 'SQL File',
  'file-management.fileTypes.db': 'Database File',
  'file-management.fileTypes.sqlite': 'SQLite Database',
  'file-management.fileTypes.sqlite3': 'SQLite3 Database',
  // Font types
  'file-management.fileTypes.ttf': 'TrueType Font',
  'file-management.fileTypes.otf': 'OpenType Font',
  'file-management.fileTypes.woff': 'WOFF Font',
  'file-management.fileTypes.woff2': 'WOFF2 Font',
  'file-management.fileTypes.eot': 'EOT Font',
  // Other types
  'file-management.fileTypes.exe': 'Executable File',
  'file-management.fileTypes.dll': 'Dynamic Link Library',
  'file-management.fileTypes.msi': 'Windows Installer',
  // Permission center & governance
  'file-management.permissionCenter.title': 'Permission Center',
  'file-management.permissionCenter.subtitle':
    'Configure visibility and ACL access for files and folders',
  'file-management.permissionCenter.reloadAll': 'Refresh all',
  'file-management.permissionCenter.forbidden.title': 'No access',
  'file-management.permissionCenter.forbidden.subtitle':
    'This page is only available to tenant or organization admins',
  'file-management.permissionCenter.tab.file': 'File settings',
  'file-management.permissionCenter.tab.folder': 'Folder settings',
  'file-management.permissionCenter.file.title': 'File settings',
  'file-management.permissionCenter.file.detailTitle': 'File settings detail',
  'file-management.permissionCenter.file.searchPlaceholder': 'Search files',
  'file-management.permissionCenter.file.exceptionSearchPlaceholder':
    'Search files with policy',
  'file-management.permissionCenter.file.addExceptionPlaceholder':
    'Search file to add policy',
  'file-management.permissionCenter.file.appIdPlaceholder':
    'Filter by source app',
  'file-management.permissionCenter.file.refresh': 'Refresh',
  'file-management.permissionCenter.folder.title': 'Folder settings',
  'file-management.permissionCenter.folder.detailTitle':
    'Folder settings detail',
  'file-management.permissionCenter.folder.refresh': 'Refresh',
  'file-management.permissionCenter.folder.loading': 'Loading',
  'file-management.permissionCenter.folder.noActiveStorage':
    'No active storage config, folder tree is unavailable',
  'file-management.permissionCenter.column.fileName': 'File name',
  'file-management.permissionCenter.column.updatedAt': 'Updated at',
  'file-management.permissionCenter.column.app': 'App',
  'file-management.permissionCenter.column.visibility': 'Visibility',
  'file-management.permissionCenter.column.sensitivity': 'Sensitivity',
  'file-management.permissionCenter.view.admin': 'Admin view',
  'file-management.permissionCenter.view.app': 'App files',
  'file-management.permissionCenter.visibility.inherit': 'Inherit policy',
  'file-management.permissionCenter.visibility.private': 'App-only',
  'file-management.permissionCenter.visibility.custom': 'Custom ACL',
  'file-management.permissionCenter.visibility.organization': 'Organization',
  'file-management.permissionCenter.visibility.tenant': 'Tenant-wide',
  'file-management.permissionCenter.sensitivity.normal': 'Normal',
  'file-management.permissionCenter.sensitivity.confidential': 'Confidential',
  'file-management.permissionCenter.sensitivity.restricted': 'Restricted',
  'file-management.permissionCenter.app.unconfigured': 'Unconfigured',
  'file-management.permissionCenter.app.fileManage': 'File Management',
  'file-management.permissionCenter.message.loadAppNamesFailed':
    'Failed to load app names',
  'file-management.permissionCenter.message.loadFilesFailed':
    'Failed to load files',
  'file-management.permissionCenter.message.loadFoldersFailed':
    'Failed to load folder tree',
  'file-management.permissionCenter.message.loadAppPolicyFailed':
    'Failed to load app default policy',
  'file-management.permissionCenter.message.loadFolderPolicyFailed':
    'Failed to load folder policy',
  'file-management.permissionCenter.message.loadFilePolicyFailed':
    'Failed to load file effective policy',
  'file-management.permissionCenter.message.loadFileExceptionsFailed':
    'Failed to load file policies',
  'file-management.permissionCenter.message.saveAppPolicySuccess':
    'App default policy saved',
  'file-management.permissionCenter.message.saveAppPolicyFailed':
    'Failed to save app default policy',
  'file-management.permissionCenter.message.saveFolderPolicySuccess':
    'Folder policy saved',
  'file-management.permissionCenter.message.saveFolderPolicyFailed':
    'Failed to save folder policy',
  'file-management.permissionCenter.message.saveRootPolicySuccess':
    'Root policy saved',
  'file-management.permissionCenter.message.selectSourceAppFirst':
    'Please select source app first',
  'file-management.permissionCenter.message.saveFileExceptionSuccess':
    'File policy saved',
  'file-management.permissionCenter.message.saveFileExceptionFailed':
    'Failed to save file policy',
  'file-management.permissionCenter.message.clearFileExceptionSuccess':
    'File policy removed',
  'file-management.permissionCenter.message.clearFileExceptionFailed':
    'Failed to remove file policy',
  'file-management.permissionCenter.column.exception': 'Exception',
  'file-management.permissionCenter.file.exception.yes': 'Has exception',
  'file-management.permissionCenter.file.exception.no': 'Inherited',
  'file-management.permissionCenter.sourceApp.placeholder': 'Select source app',
  'file-management.permissionCenter.appPolicy.hint':
    'Default policy is the fallback for all resources in this source app.',
  'file-management.permissionCenter.action.saveAppPolicy':
    'Save default policy',
  'file-management.permissionCenter.action.saveFolderPolicy':
    'Save folder policy',
  'file-management.permissionCenter.action.saveFileException':
    'Save file policy',
  'file-management.permissionCenter.action.clearFileException':
    'Clear file policy',
  'file-management.permissionCenter.folder.mode.inherit': 'Inherit parent',
  'file-management.permissionCenter.folder.mode.custom': 'Custom policy',
  'file-management.permissionCenter.folder.inheritEmpty':
    'Parent has no explicit policy rules',
  'file-management.permissionCenter.folder.rootNode': 'Root folder',
  'file-management.permissionCenter.folder.rootHint':
    'Root folder policy equals app default policy',
  'file-management.permissionCenter.folder.effectiveFrom':
    'Effective from: {value}',
  'file-management.permissionCenter.folder.defaultPolicy':
    'Default folder policy',
  'file-management.permissionCenter.folder.selectFolder':
    'Select a folder to configure policy',
  'file-management.permissionCenter.fileException.title': 'File policy',
  'file-management.permissionCenter.fileException.addRules': 'Add rules',
  'file-management.permissionCenter.fileException.removeRules': 'Remove rules',
  'file-management.permissionCenter.fileException.addRemoveRule':
    'Add removal rule',
  'file-management.permissionCenter.file.selectFile':
    'Select a file to configure policy',
  'file-management.permissionCenter.tab.appDefault': 'App default policy',
  'file-management.permissionCenter.tab.folderPolicy': 'Folder policy',
  'file-management.permissionCenter.tab.fileException': 'File policy',
  'file-management.governance.title.file': 'File settings',
  'file-management.governance.title.folder': 'Folder settings',
  'file-management.governance.title.fileException': 'File policy',
  'file-management.governance.tab.overview': 'Settings',
  'file-management.governance.tab.acl': 'ACL',
  'file-management.governance.desc.resourceUuid': 'Resource UUID',
  'file-management.governance.desc.fileName': 'File name',
  'file-management.governance.desc.inheritedFrom': 'Inherited from',
  'file-management.governance.desc.app': 'App',
  'file-management.governance.desc.lifecycle': 'Lifecycle',
  'file-management.governance.desc.effectivePermissions':
    'Effective permissions',
  'file-management.governance.desc.none': 'None',
  'file-management.governance.form.fileName': 'File name',
  'file-management.governance.form.description': 'Description',
  'file-management.governance.form.category': 'Category',
  'file-management.governance.form.tags': 'Tags',
  'file-management.governance.form.folderName': 'Folder name',
  'file-management.governance.form.visibility': 'Visibility',
  'file-management.governance.form.sensitivity': 'Sensitivity',
  'file-management.governance.form.sourceAppId': 'Source App ID',
  'file-management.governance.form.sourceAppPlaceholder':
    'e.g. file_manage / knowledge',
  'file-management.governance.form.saveOverview': 'Save Settings',
  'file-management.governance.visibility.inherit': 'Inherit source app policy',
  'file-management.governance.visibility.private': 'App-only',
  'file-management.governance.visibility.custom': 'Custom ACL',
  'file-management.governance.sensitivity.normal': 'Normal',
  'file-management.governance.sensitivity.confidential': 'Confidential',
  'file-management.governance.sensitivity.restricted': 'Restricted',
  'file-management.governance.lifecycle.title': 'Lifecycle',
  'file-management.governance.lifecycle.archive': 'Archive',
  'file-management.governance.lifecycle.restore': 'Restore',
  'file-management.governance.lifecycle.recycle': 'Move to Recycle Bin',
  'file-management.governance.lifecycle.purge': 'Purge',
  'file-management.governance.lifecycle.confirmRecycle':
    'Move this file to recycle bin?',
  'file-management.governance.lifecycle.confirmPurgeTitle':
    'Permanently purge this file?',
  'file-management.governance.lifecycle.confirmPurgeDesc':
    'This action will try to delete the object from storage and the file will no longer appear in file list.',
  'file-management.governance.lifecycle.help':
    'Active files are accessible. Archived files are retained but inactive. Recycled files can only be restored or purged.',
  'file-management.governance.lifecycle.status.active': 'Active',
  'file-management.governance.lifecycle.status.uploading': 'Uploading',
  'file-management.governance.lifecycle.status.archived': 'Archived',
  'file-management.governance.lifecycle.status.recycled': 'Recycled',
  'file-management.governance.lifecycle.status.purged': 'Purged',
  'file-management.governance.empty.selectResource':
    'Select a resource to start configuration',
  'file-management.governance.empty.noGovernancePermission':
    'Only tenant or organization admins can view settings',
  'file-management.governance.empty.fileOnly':
    'Folder ACL should be configured in Permission Center > Folder policy.',
  'file-management.governance.message.loadDetailFailed':
    'Failed to load governance detail',
  'file-management.governance.message.saveOverviewSuccess': 'Settings saved',
  'file-management.governance.message.saveOverviewFailed':
    'Failed to save settings',
  'file-management.governance.message.noPermissionToSave':
    'No permission to save configuration',
  'file-management.governance.message.saveAclSuccess': 'ACL saved',
  'file-management.governance.message.saveAclFailed': 'Failed to save ACL',
  'file-management.governance.message.updateLifecycleFailed':
    'Failed to update lifecycle',
  'file-management.governance.message.archiveSuccess': 'File archived',
  'file-management.governance.message.restoreSuccess':
    'File restored to active',
  'file-management.governance.message.recycleSuccess':
    'File moved to recycle bin',
  'file-management.governance.message.purgeSuccess': 'File permanently purged',
  'file-management.governance.message.clearFileExceptionSuccess':
    'File policy removed',
  'file-management.governance.message.clearFileExceptionFailed':
    'Failed to remove file policy',
  'file-management.governance.fileException.addRules': 'Add rules',
  'file-management.governance.fileException.removeRules': 'Remove rules',
  'file-management.governance.fileException.addRemoveRule': 'Add removal rule',
  'file-management.governance.fileException.save': 'Save policy',
  'file-management.governance.fileException.clear': 'Clear policy',
  'file-management.aclPackEditor.column.subject': 'Subject',
  'file-management.aclPackEditor.column.subjectId': 'Subject ID',
  'file-management.aclPackEditor.column.permissionPack': 'Permission pack',
  'file-management.aclPackEditor.column.expiresAt': 'Expires at',
  'file-management.aclPackEditor.expiresAt.permanent': 'Permanent',
  'file-management.aclPackEditor.column.action': 'Action',
  'file-management.aclPackEditor.subjectId.placeholder':
    'Input ID for role/app if needed',
  'file-management.aclPackEditor.addRule': 'Add rule',
  'file-management.aclPackEditor.empty': 'No ACL rules',
  'file-management.subjectPicker.type.member': 'Member',
  'file-management.subjectPicker.type.organization': 'Organization/Tenant',
  'file-management.subjectPicker.type.role': 'Role',
  'file-management.subjectPicker.type.app': 'App',
  'file-management.subjectPicker.member.placeholder':
    'Search member (nickname/phone)',
  'file-management.subjectPicker.organization.placeholder':
    'Select organization/tenant',
  'file-management.subjectPicker.role.placeholder': 'Select role',
  'file-management.subjectPicker.role.admin': 'Admin',
  'file-management.subjectPicker.role.everyone': 'Everyone',
  'file-management.subjectPicker.app.placeholder': 'Input app identifier',
  'file-management.subjectPicker.empty': 'No data',
  'file-management.aclPack.read': 'Read',
  'file-management.aclPack.edit': 'Edit',
  'file-management.aclPack.manage': 'Manage',
  'file-management.aclPack.read.desc': 'Read: view/preview/download',
  'file-management.aclPack.edit.desc':
    'Edit: read + upload/rename/move/replace content/edit metadata',
  'file-management.aclPack.manage.desc':
    'Manage: edit + delete/archive/restore/share/manage acl/manage reference',
  'file-management.permission.label.view': 'View',
  'file-management.permission.label.preview': 'Preview',
  'file-management.permission.label.download': 'Download',
  'file-management.permission.label.upload': 'Upload',
  'file-management.permission.label.rename': 'Rename',
  'file-management.permission.label.move': 'Move',
  'file-management.permission.label.replace_content': 'Replace Content',
  'file-management.permission.label.edit_metadata': 'Edit Metadata',
  'file-management.permission.label.delete': 'Delete',
  'file-management.permission.label.archive': 'Archive',
  'file-management.permission.label.restore': 'Restore',
  'file-management.permission.label.share': 'Share',
  'file-management.permission.label.manage_acl': 'Manage ACL',
  'file-management.permission.label.manage_reference': 'Manage Reference',
  'file-management.fileLibrary.governanceException.noPermission':
    'Only tenant or organization admins can view file policy',
  'file-management.fileLibrary.share.onlyOwnerOrAdmin':
    'Only tenant/org admins or file owner can share this file',
  'file-management.fileLibrary.action.exception': 'File policy',
  'file-management.fileLibrary.drawer.exceptionTitle': 'File policy: {name}',
  'file-management.appBrowser.searchApp': 'Search application name or ID',
  'file-management.appBrowser.deleteFolder': 'Delete folder',
  'file-management.appBrowser.deleteFolderTitle': 'Delete folder "{name}"?',
  'file-management.appBrowser.deleteFolderDescription':
    'Selected folders, all files and subfolders inside will be permanently deleted.',
  'file-management.appBrowser.deleteSelectedTitle':
    'Delete selected files and folders?',
  'file-management.appBrowser.deleteConfirm': 'Delete',
  'file-management.appBrowser.deleteCancel': 'Cancel',
  'file-management.appBrowser.deleteSuccess': 'Deleted successfully',
  'file-management.appBrowser.deleteFailed':
    'Deletion failed. Some items may already be deleted; refresh to check.',
  'file-management.appBrowser.deletePartial':
    'Deleted {deleted} objects; {failed} failed. Refresh and retry.',
};
